module.exports = __webpack_public_path__ + "img/icons8-download.38fd131c.svg";